import React, { useState, useEffect } from "react";
import Scrollspy from "react-scrollspy";
import texts from "../texts.json";
import BounceLoader from "react-spinners/BounceLoader";
import BackgroundSlider from "react-background-slider";
import Fade from "react-reveal/Fade";

import AboutUsComponent from "../components/about/index";
import FeaturesComponent from "../components/features/index";
import MarbleComponent from "../components/marble/index";
import ContactUsComponent from "../components/contact/index";
import MapComponent from "../components/map";
import FooterComponent from "../components/footer/index";

import "./index.css";

import horizontalLogo from "../images/horizontal-logo.png";
import arrowTop from "../images/up-arrow.png";
import image2 from "../images/img-02.jpg";
import logo from "../images/vertical-logo-padding.png";
import fachada from "../images/fachada.jpeg";
import maquinas from "../images/maquinas.jpg";


var LANGUAGES = [
  { id: "pt-br", text: "PT", img: "brasil.png" },
  { id: "en", text: "EN", img: "uk.png" },
  { id: "it", text: "IT", img: "italia.png" },
];

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
    document.getElementById("navbar").style.padding = "0px 0px";
  } else {
    document.getElementById("navbar").style.padding = "10px 10px";
  }

  if (
    document.body.scrollTop > 500 ||
    document.documentElement.scrollTop > 500
  ) {
    document.getElementById("back-top").style.display = "block";
  } else {
    document.getElementById("back-top").style.display = "none";
  }
}

const Home = () => {
  const [burgerState, setBurgerState] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(LANGUAGES[0]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [otherLanguages, setOtherLanguages] = useState([
    LANGUAGES[1],
    LANGUAGES[2],
  ]);

  useEffect(() => {
    let aux = [];

    LANGUAGES.forEach((lang) => {
      if (lang !== currentLanguage) {
        aux.push(lang);
      }
    });

    setIndex(LANGUAGES.indexOf(currentLanguage));
    setOtherLanguages(aux);
  }, [currentLanguage]);

  useEffect(() => {
    if (!loading) {
      document.getElementById("navbar").style.display = "flex";
    }
  }, [loading]);

  function burgerStateChanged() {
    setBurgerState(!burgerState);
    const navLinks = document.querySelectorAll(".nav-links li");

    if (!burgerState) {
      navLinks.forEach((link, index) => {
        link.style.animation = `navLinkFade 0.5s ease forwards ${
          index / 7 + 0.4
        }s`;
      });
    } else {
      navLinks.forEach((link, index) => {
        link.style.animation = "";
      });
    }
  }

  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <div>
      <div className="container-menu">
        <nav id="navbar">
          <img alt="GF ESTRAZIONI" className="logo" id="logo" src={horizontalLogo} />

          <Scrollspy
            items={["home", "story", "marble", "contact"]}
            currentClassName="selected"
            className={burgerState ? "nav-links nav-active" : "nav-links"}
          >
            <li>
              <a href="#home">{texts.menu.home[index]}</a>
            </li>
            <li>
              <a href="#story">{texts.menu.historia[index]}</a>
            </li>
            <li>
              <a href="#marble">{texts.menu.marmore[index]}</a>
            </li>
            <li>
              <a href="#contact">{texts.menu.contato[index]}</a>
            </li>
            <div className="li-dropdown">
              <button>
                <img
                  alt="Flag"
                  src={require("../images/" + currentLanguage.img)}
                  className="flag"
                />
              </button>

              <div className="dropdown-content">
                <button onClick={() => setCurrentLanguage(otherLanguages[0])}>
                  <img
                    alt="Flag"
                    src={require("../images/" + otherLanguages[0].img)}
                    className="flag"
                  />
                </button>
                <button onClick={() => setCurrentLanguage(otherLanguages[1])}>
                  <img
                    alt="Flag"
                    src={require("../images/" + otherLanguages[1].img)}
                    className="flag"
                  />
                </button>
              </div>
            </div>
          </Scrollspy>

          <div
            className={burgerState ? "burger toggle" : "burger"}
            onClick={burgerStateChanged}
          >
            <div className="line-one"></div>
            <div className="line-two"></div>
            <div className="line-three"></div>
          </div>
        </nav>

        <button onClick={topFunction} id="back-top" title="Go to Top">
          <img src={arrowTop} alt="Go to Top" className="arrow-top" />
        </button>
      </div>

      <div className="home-section" id="home">
        <div className="div-loader" id="loader">
          <BounceLoader size={150} color={"#dddddd"} loading={loading} />
        </div>
        <Fade>
          <div className="home-logo">
            <img
              src={logo}
              alt="GF ESTRAZIONI"
              className="img-logo"
              onLoad={() => setLoading(false)}
            />
          </div>
        </Fade>

        <div className="slider-bg-div">
          <BackgroundSlider
            images={[fachada,image2, maquinas]}
            duration={6}
            transition={1}
          />
        </div>
      </div>

        <AboutUsComponent index={index} />

        <FeaturesComponent index={index} />

        <MarbleComponent index={index} />
        <ContactUsComponent index={index} />
        <MapComponent />
        <FooterComponent index={index} />
    </div>
  );
};

export default Home;
